export const KIDSPLAZA_V2_ASSETS_BASE_URL = `${process.env.NEXT_PUBLIC_CDN_BASE_URL ?? ''}/assets`;

export const getImageAssetUrl = (path: string): string => {
    return `${KIDSPLAZA_V2_ASSETS_BASE_URL}/${path}`;
};

export const productPlaceholder = getImageAssetUrl('placeholders/product.svg');
